module.exports = __webpack_public_path__ + "static/img/douyin.67433c85.png";